import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RegionMappingService {
  private readonly STORAGE_KEY = 'region_mappings';
  
  // Défaut : Les régions administratives standard
  // Clé = Région FFSLC (ex: 'Région 3')
  // Valeur = Région Admin (ex: 'Hauts-de-France')
  // Ou l'inverse : Clé = Région Admin, Valeur = Région FFSLC
  // Faisons Clé = Région Admin (c'est ce qu'on reçoit de la carte), Valeur = Région FFSLC
  
  public mappings = signal<Record<string, string>>({});

  public adminRegions = [
    'Auvergne-Rhône-Alpes',
    'Bourgogne-Franche-Comté',
    'Bretagne',
    'Centre-Val de Loire',
    'Corse',
    'Grand Est',
    'Hauts-de-France',
    'Île-de-France',
    'Normandie',
    'Nouvelle-Aquitaine',
    'Occitanie',
    'Pays de la Loire',
    "Provence-Alpes-Côte d'Azur"
  ];

  public ffslcRegions = [
    'Non attribuée',
    'Région 1', 'Région 2', 'Région 3', 'Région 4',
    'Région 5', 'Région 6', 'Région 7', 'Région 8',
    'Région 9', 'Région 10', 'Région 11', 'Région 12'
  ];

  constructor() {
    this.loadMappings();
  }

  loadMappings() {
    const stored = localStorage.getItem(this.STORAGE_KEY);
    if (stored) {
      try {
        this.mappings.set(JSON.parse(stored));
      } catch (err) {
        console.error('Erreur lecture region mappings', err);
      }
    } else {
      // Init mappings vides
      const defaultMappings: Record<string, string> = {
        'Hauts-de-France': 'Région 3',
        // On peut ajouter les autres mappings petit a petit, mais on configure au moins Region 3
      };
      // Remplir les autres régions avec chaîne vide pour qu'elles s'affichent dans l'admin
      this.adminRegions.forEach(ar => {
        if (!defaultMappings[ar]) defaultMappings[ar] = '';
      });
      this.mappings.set(defaultMappings);
    }
  }

  saveMappings(newMap: Record<string, string>) {
    this.mappings.set(newMap);
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(newMap));
  }

  // Renvoie "Région 3" quand on donne "Hauts-de-France"
  getFfslcRegion(adminRegion: string): string | null {
    if (!adminRegion) return null;
    const map = this.mappings();
    const normalizedAdmin = adminRegion.toLowerCase().replace(/[^a-z0-9]/g, '');
    for (const [key, value] of Object.entries(map)) {
      if (key.toLowerCase().replace(/[^a-z0-9]/g, '') === normalizedAdmin) {
        return value || null; // Return the FFSLC region, or null if unassigned
      }
    }
    return null;
  }

  // Renvoie ["Hauts-de-France"] ou ["Bretagne", "Pays de la Loire"] quand on donne "Région X"
  getAdminRegions(ffslcRegion: string): string[] {
    if (!ffslcRegion) return [];
    const map = this.mappings();
    const normalizedFfslc = ffslcRegion.trim().toLowerCase();
    const results: string[] = [];
    for (const [key, value] of Object.entries(map)) {
      if (value && value.trim().toLowerCase() === normalizedFfslc) {
        results.push(key);
      }
    }
    return results; 
  }
}
